import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-academic-year',
  imports: [SharedModule],
  templateUrl: './create-academic-year.component.html',
  styleUrl: './create-academic-year.component.scss'
})
export class CreateAcademicYearComponent {


  @Input() type: string = 'Create';
  @Input() academicYearData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();
  @Input() users: any[] = []; // Assuming users are passed as input
  attachments: any[] = []; // Store selected files

  isSubmitted = false;
  btnLoading = false;

  academicYearForm: FormGroup;

  loading = false;


  statusOptions = ["Active", "Inactive"];


  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: AcademicYearService,
    private localStorage: LocalStorageService
  ) {
    this.academicYearForm = this.fb.group({
      year_name: ['', Validators.required],
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      status: ['Active', Validators.required],
      organization_id: [this.localStorage.getOrganizationId() || ''],
      campus_id: [this.localStorage.getCampusId() || '']
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.academicYearData) {
      console.log('Updating academic year with data:', this.academicYearData);

      this.academicYearForm.patchValue({
        year_name: this.academicYearData.year_name,
        start_date: new Date(this.academicYearData.start_date),
        end_date: new Date(this.academicYearData.end_date),
        status: this.academicYearData.status,
        organization_id: this.academicYearData.organization_id,
        campus_id: this.academicYearData.campus_id
      });

    }


  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.academicYearForm.valid) {
      const formValues = this.academicYearForm.value;

      this.btnLoading = true;
      const payload = this.academicYearForm.value;

      const apiCall = this.type === 'Create'
        ? this.api.createAcademicYear(payload)
        : this.api.updateAcademicYear({
          id: this.academicYearData.id,
          ...payload
        });

      apiCall.subscribe({
        next: (res) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: `Academic Year ${this.type === 'Create' ? 'created' : 'updated'} successfully` });
          this.academicYearForm.reset();
          this.isSubmitted = false;
          this.reload.emit();
          this.handleCloseDialog();
          this.btnLoading = false;

        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `Failed to ${this.type.toLowerCase()} Academic Year` });
          this.btnLoading = false;
        }
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: 'Please fill all required fields' });
    }
  }




}
